import React, { Component } from 'react';
import { connect } from 'react-redux';
import Fetch from '../../common/Fetch';
import API_URL from "../../common/url";
import { Spin, Modal } from 'antd';
import ENV from '../../common/env.js';
import { saveSearchParams } from '../../actions/noticeActions';
import { saveParams } from '../../actions/homeActions';
import $ from '../../common/AjaxRequest.js';

const setInvState = () => {
    const { invId, siteId, investigationSiteName } = sessionStorage;
    if (invId && invId > 0) {
        if (siteId > 0) {
            // 具体项目
            sessionStorage.invState = 2;
        } else if (investigationSiteName) {
            // 中心汇总
            sessionStorage.invState = 1;
            sessionStorage.removeItem('relatedSiteId');
        } else {
            // 配置项目
            sessionStorage.invState = 3;
            sessionStorage.removeItem('relatedSiteId');
        }
    } else {
        // 项目外
        sessionStorage.invState = 0;
        sessionStorage.invId = '';
        sessionStorage.removeItem('blindType');
        sessionStorage.removeItem('blindInvId');
        sessionStorage.removeItem('blindInvName');
        sessionStorage.removeItem('relatedSiteId');
    }
}

export default function (WrappedComponent) {
    class WrapperComponent extends Component {
        state = {
            show: false,
            update: null,
            loading: false
        }

        componentDidMount() {
            const { logOutUrl } = sessionStorage;
            this.checkLogin();
            if (logOutUrl && !this.state.show) {
                this.setState({ show: true });
            }
            this.updateSession();
            this.getCrcSourcePlatform();
            localStorage.setItem('is401', 0);
            // 处理浏览器返回按钮不更新SessionStorage
            window.addEventListener('hashchange', this.updateSession);
        }

        componentWillReceiveProps() {
            this.checkLogin();
            setInvState();
        }

        componentWillUnmount() {
            window.removeEventListener('hashchange', this.updateSession);
        }

        updateSession = () => {
            setInvState();
            this.queryProjectInfo();
        }

        queryProjectInfo = () => {
            const { invState, invId, siteId, blindType } = sessionStorage;
            if (invState == 2 && !this.loadingProject && !blindType) {
                this.loadingProject = true;
                this.setState({ loading: true });
                Promise.all([
                    Fetch.post(API_URL.investigation.queryInvestigationByName, { investigationId: invId }),
                    Fetch.post(API_URL.site.list, { siteId }),
                ]).then(res => {
                    this.parseInvestigation(res[0]);
                    this.parseCenter(res[1]);
                    this.setState({ update: {} });
                }).finally(() => {
                    this.loadingProject = false;
                    this.setState({ loading: false });
                })
            } else if ((invState == 1 || invState == 3) && !this.loadingProject && !blindType) {
                this.loadingProject = true;
                this.setState({ loading: true });
                Fetch.post(API_URL.investigation.queryInvestigationByName, { investigationId: invId })
                    .then(res => {
                        this.parseInvestigation(res);
                        this.setState({ update: {} });
                    })
                    .finally(() => {
                        this.loadingProject = false;
                        this.setState({ loading: false });
                    });
            }
        }

        parseInvestigation = (res) => {
            const [investigation] = res.data || [];
            const { blindType, blindInvestigationId, blindInvestigationName } = investigation || {};

            sessionStorage.setItem('blindType', blindType || 'BLIND');
            sessionStorage.setItem('blindInvId', blindInvestigationId || '');
            sessionStorage.setItem('blindInvName', blindInvestigationName || '');
        }

        parseCenter = (res) => {
            const [center] = res.data.siteList.datas || [];
            const { relatedId } = center || {};

            sessionStorage.setItem('relatedSiteId', relatedId || '');
        }

        showConfirm = () => {
            Modal.warning({
                title: '该用户无SMO系统权限',
                content: '该用户无SMO系统权限',
                onOk: () => {
                    sessionStorage.clear();
                    // location.href = ENV.LOGOUT_URL;
                },
            });
        }

        getCrcSourcePlatform = () => {
            const { userId, curRole, crcSourcePlatformUrl } = sessionStorage;
            const role = curRole == 'BO' || curRole == 'CRCC' || curRole == 'CRCM';
            if (userId && role && !crcSourcePlatformUrl && !this.loadCrcUrl) {
                this.loadCrcUrl = true;
                Fetch.post(API_URL.config.getCrcSourcePlatform, { type: 'CRC_SOURCE_PLATFORM' })
                    .then(res => {
                        sessionStorage.setItem('crcSourcePlatformUrl', btoa(res.data));
                    })
                    .finally(() => {
                        this.loadCrcUrl = false;
                    });
            }
        }

        getCrcEvaluateRemindMessage = () => {
            Fetch.post(API_URL.notice.getCrcEvaluateRemindMessage)
                .then(res => {
                    const { data } = res;
                    if ((data || []).length) {
                        this.props.saveParams({
                            showCrcQualitySheet: true,
                            qualitySheetNewsList: data,
                        });
                    }
                    this.setState({ show: true });
                });
        }

        getUserInfo = () => {
            Fetch.post(API_URL.user.getUserInfo, { employeeCode: sessionStorage.employeeCode })
                .then(result => {
                    if (result.error) {
                        console.error(result.error);
                        this.showConfirm();
                        return;
                    } else if (result.data.error) {
                        console.error(result.data.error);
                    } else {
                        sessionStorage.userId = result.data.user.userId;
                        sessionStorage.positionName =
                            result.data.user.positionName != undefined && result.data.user.positionName != null ?
                                result.data.user.positionName : '';
                        sessionStorage.userName = result.data.user.userCompellation;
                        sessionStorage.curEnterpriseId = result.data.user.enterpriseId;
                        sessionStorage.positionRole =result.data.positionRole;
                        sessionStorage.curRole =result.data.positionRole;
                        sessionStorage.curEmployeeCode = sessionStorage.employeeCode;
                        sessionStorage.invName = '';
                        sessionStorage.invId = '';
                        sessionStorage.siteId = '';
                        if (!sessionStorage.positionRole) {
                            Modal.error({ title: '您的职位尚未配置操作权限，无法访问，请联系企业管理员配置后重试。' });
                            //TODO:  to do logout  上线前修改为saml logout
                            sessionStorage.clear();
                            // location.href = `${API_URL.config.logoutUrl}`;
                        } else {
                            const { adjustmentNotices: list } = result.data;
                            if (list && list.length && list.some(i => (i.status == 'NEW' || i.status == 'DELAY'))) {
                                this.props.saveParams({ expectHour: true });
                                this.props.saveSearchParams({ 
                                    noticeType: 'PLAN_FTE_ADJUSTMENT', 
                                    noticeValue:'预计工时调整提醒', 
                                    activeKey:'Notice',  
                                });
                            }
                            //中心关联提醒
                            {
                                const { contactSiteNotices: list } = result.data;
                                if (list && list.length ) {
                                    this.props.saveParams({ centerRelate: true });
                                    this.props.saveSearchParams({ 
                                        noticeType: 'CONTRACT_RELATE_SITE', 
                                        noticeValue:'中心关联合同通知', 
                                        activeKey:'Notice',
                                    });
                                }
                            }
                            //办事流程确认提醒
                            {
                                const { ssuHospitalNotices: list } = result.data;
                                if (list && list.length ) {
                                    this.props.saveParams({ infoConfirm: true });
                                    this.props.saveSearchParams({ 
                                        noticeType: 'SSU_HOSPITAL_INFO_CONFIRM', 
                                        noticeValue:'办事流程确认提醒', 
                                        activeKey:'Backlog',
                                    });
                                }
                            }
                            if (sessionStorage.positionRole === 'CRC') {
                                this.getCrcEvaluateRemindMessage();
                            } else {
                                this.setState({ show: true });
                            }
                        }
                    }
                });
        }

        checkLogin = () => {
            const { userId, employeeCode } = sessionStorage;
            let isLogin = userId != undefined && userId != null && userId > 0;
            const loginPage = location.hash.substr(1) == "/login" ;
            // 没有登录且不是登录页
            if (!isLogin && !loginPage) {
                if (employeeCode) {
                    this.getUserInfo();
                } else {
                    const options = {
                        url: `${API_URL.user.getEmployeeCode}`,
                        data: {},
                        dataType: 'json',
                        doneResult: (res) => {
                            const { errorCode, redirectUrl, error } = res;
                            if(errorCode == 401) {
                                location.href = redirectUrl;
                            } else if(errorCode == 406 && error ) {
                                message.error(error);
                            } else {
                                const { employeeCode, showLogoutButton, tokenInfo: { tokenName,  tokenValue, loginType } } = res;
                                sessionStorage.employeeCode = employeeCode;
                                localStorage.setItem('tokenValue', tokenValue);
                                localStorage.setItem('tokenName', tokenName);
                                localStorage.setItem('loginType', loginType || 'ADFS');
                                localStorage.setItem('is401', 0);
                                localStorage.setItem('showLogoutButton', showLogoutButton)
                                this.getUserInfo();
                            }
                        },
                    };
                    $.sendRequest(options);
                }
            } else {
                this.setState({ show: true });
            }
        }

        queryUserInfo = () => {
            Fetch.post(API_URL.config.getUserInfo)
                .then(res => {
                    if (res.userId) {
                        const { positionRole, userId = '', enterpriseId = '', positionName, userCompellation = '', logOutUrl = '' } = res;
                        sessionStorage.curRole = positionRole || '';
                        sessionStorage.positionRole = positionRole || '';
                        sessionStorage.positionName = positionName || '';
                        sessionStorage.userId = userId;
                        sessionStorage.userName = userCompellation;
                        sessionStorage.curEnterpriseId = enterpriseId;
                        sessionStorage.logOutUrl = logOutUrl;
                        sessionStorage.invName = '';
                        sessionStorage.invId = '';
                        sessionStorage.siteId = '';

                        this.setState({
                            show: true,
                        }, () => {
                            location.href = `./#/home`;
                        });
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        }

        backToLogin = () => {
            sessionStorage.clear();
            // location.href = `${API_URL.config.logoutUrl}`;
        }

        render() {
            const { show, update, loading } = this.state;
            const { positionRole } = sessionStorage;
            return (
                show ?
                    (positionRole ?
                            <Spin spinning={loading}>
                                <WrappedComponent update={update} {...this.props} />
                            </Spin>
                        :
                            <div className="no_position">
                                <div className="back_login" onClick={() => { this.backToLogin() }}></div>
                                <img className="no_position_img" src={require('../../../public/no_position.png')} alt="" />
                            </div>
                    )
                    :
                    <Spin tip="加载用户数据..." style={{ position: "fixed", top: "50%", left: "50%" }} />
            );
        }
    }

    const mapDispatchToProps = (dispatch) => {
        return {
            saveParams: (params) => dispatch(saveParams(params)),
            saveSearchParams: (params) => dispatch(saveSearchParams(params))
        }
    }

    return connect(null, mapDispatchToProps)(WrapperComponent);
};


// WEBPACK FOOTER //
// ./src/components/auth/withCheckUser.js